/* file description */

import { transformNumber2TableColumn } from './transformNumber2TableColumn';
import { transformString2TableColumn } from './transformString2TableColumn';
import { LCP_FIELD_KINDS, LCP_EFECT_KINDS } from './consts';
import { transformLinkShowRecord2Column } from './transformLinkShowRecord2Column';
import { transformBoulderaiRole2TableColumn } from './transformBoulderaiRole2TableColumn';
import { transformBoulderaiUser2TableColumn } from './transformBoulderaiUser2TableColumn';
import { transformUpload2TableColumn } from './transformUpload2TableColumn';
import { transformReference2TableColumn } from './tansformReference2Column';
import { transformText2TableColumn } from './transformText2TableColumn';
import { transformArea2Column } from './transformArea2Column';
import { transformAseetCheckboxColumn } from './transformAseetCheckboxColumn';
import { transformAseetRadioColumn } from './transformAseetRadioColumn';
import { transformQrCodeTableColumn } from './transformQrCodeTableColumn';
import { transformAssetBoolColumn } from './transformAssetBoolColumn';
import { transformAssetDateTime2TableColumn } from './transformAssetDateTime2TableColumn';
import { transformDepUserColumn } from './transformDepUserColumn';
import { transformProductSelectColumn } from './transformProductSelectColumn';
import { transformOpenApiSelectColumn } from './transformOpenApiSelectColumn';
/**
 * @desc: 映射低代码扳手类型(kind)与对应的转换原子组件类型(SPField-valueType)的函数
 */

export const FIELD_LCP_TABLE_MAP = (() => {
  const fieldLCPMap = new Map();
  // start - anymap here
  // 低代码扳手类型-mapSets
  fieldLCPMap.set(LCP_FIELD_KINDS.STRING, transformString2TableColumn);
  fieldLCPMap.set(LCP_FIELD_KINDS.NUMBER, transformNumber2TableColumn);
  // fieldLCPMap.set(LCP_FIELD_KINDS.EMAIL, transformEmail2TableColumn);
  // fieldLCPMap.set(LCP_FIELD_KINDS.URL, transformUrl2TableColumn);
  // fieldLCPMap.set(LCP_FIELD_KINDS.PHONE, transformPhone2TableColumn);
  // fieldLCPMap.set(LCP_FIELD_KINDS.SELECT, transformSelect2TableColumn);
  // fieldLCPMap.set(LCP_FIELD_KINDS.RECORD_SELECT, transformRecordSelect2TableColumn);
  // fieldLCPMap.set(LCP_FIELD_KINDS.BOOL, transformBool2TableColumn);
  // fieldLCPMap.set(LCP_FIELD_KINDS.CHECKBOX, transformCheckbox2TableColumn);
  // fieldLCPMap.set(LCP_FIELD_KINDS.DATE_TIME, transformDateTime2TableColumn); // 废弃老的时间控件，统一使用新的
  fieldLCPMap.set(LCP_FIELD_KINDS.DATE_TIME, transformAssetDateTime2TableColumn);
  fieldLCPMap.set(LCP_FIELD_KINDS.BOULDERAI_ROLE, transformBoulderaiRole2TableColumn);
  fieldLCPMap.set(LCP_FIELD_KINDS.BOULDERAI_USER, transformBoulderaiUser2TableColumn);
  // fieldLCPMap.set(LCP_FIELD_KINDS.RECORD, transformRecord2TableColumn);
  fieldLCPMap.set(LCP_FIELD_KINDS.FILE, transformUpload2TableColumn);
  fieldLCPMap.set(LCP_FIELD_KINDS.REFERENCE, transformReference2TableColumn);
  // 业务组件新增
  fieldLCPMap.set(LCP_FIELD_KINDS.TEXT, transformText2TableColumn);
  fieldLCPMap.set(LCP_FIELD_KINDS.AREA_SELECT, transformArea2Column);
  fieldLCPMap.set(LCP_FIELD_KINDS.ASEET_CHECKBOX, transformAseetCheckboxColumn);
  fieldLCPMap.set(LCP_FIELD_KINDS.ASEET_RADIO, transformAseetRadioColumn);
  fieldLCPMap.set(LCP_FIELD_KINDS.QRCODE, transformQrCodeTableColumn);
  fieldLCPMap.set(LCP_FIELD_KINDS.ASSET_BOOL, transformAssetBoolColumn);
  fieldLCPMap.set(LCP_FIELD_KINDS.ASSET_DATETIME, transformAssetDateTime2TableColumn);
  fieldLCPMap.set(LCP_FIELD_KINDS.DEPUSER, transformDepUserColumn);
  fieldLCPMap.set(LCP_FIELD_KINDS.PRODUCTSELECT, transformProductSelectColumn);
  fieldLCPMap.set(LCP_FIELD_KINDS.OPENAPI_SELECT, transformOpenApiSelectColumn);

  // 低代码扳手副作用处理类型-mapSets
  fieldLCPMap.set(LCP_EFECT_KINDS.LINK_SHOW_RECORD, transformLinkShowRecord2Column);
  // fieldLCPMap.set('DateTime', 'date'); todo
  // fieldLCPMap.set('RecordSelect', 'select'); todo
  // end
  return fieldLCPMap;
})();
